import { OrganizationModel } from '../models/organization.model';
import { CollectionModel } from 'src/app/organizations/models/collection.model';
import { OrganizationInviteResponse, OrganizationUserRole, UserContentTransfer } from '../organizations.service';
import { OrganizationUserModel } from '../models/organization-user.model';

export class SetOrganizations {
  static readonly type = '[Organizations] Set Organizations';
  constructor(public organizations: OrganizationModel[]) { }
}

export class SelectOrganization {
  static readonly type = '[Organizations] Select Organization';
  constructor(public organization: OrganizationModel) { }
}

export class SelectCollection {
  static readonly type = '[Organizations] Select Collection';
  constructor(public collection: CollectionModel) { }
}

export class GetCollections {
  static readonly type = '[Organizations] Get Collections';
  constructor(public organizationId: number) { }
}

export class GetCollectionsSuccess {
  static readonly type = '[Organizations] Get Collections Success';
  constructor(public collections: CollectionModel[]) { }
}

export class JoinOrganization {
  static readonly type = '[Organizations] Join Organization';
  constructor(public organization: OrganizationModel) { }
}

export class JoinOrganizationSuccess {
  static readonly type = '[Organizations] Join Organization Success';
  constructor(public organization: OrganizationModel) { }
}

export class JoinOrganizationFail {
  static readonly type = '[Organizations] Join Organization Fail';
  constructor(public organization: OrganizationModel) { }
}

export class JoinOrganizationWithCode {
  static readonly type = '[Organizations] Join Organization With Code';
  constructor(public code: string) { }
}

export class JoinOrganizationWithCodeSuccess {
  static readonly type = '[Organizations] Join Organization With Code Success';
  constructor(public organizationName: string) { }
}

export class JoinOrganizationWithCodeFail {
  static readonly type = '[Organizations] Join Organization With Code Fail';
  constructor(public error: Error) { }
}

// Organization Invite
export class SendOrganizationInvite {
  static readonly type = '[Organizations] Send Organization Invite';
  constructor(public groupEID: string, public emails: string[]) { }
}

export class SendOrganizationInviteSuccess {
  static readonly type = '[Organizations] Send Organization Invite Success';
  constructor(public responses: OrganizationInviteResponse[]) { }
}

export class SendOrganizationInviteFail {
  static readonly type = '[Organizations] Send Organization Invite Fail';
  constructor(public error: Error) { }
}

// Get Users
export class GetOrganizationUsers {
  static readonly type = '[Organizations] Get Organization Users';
  constructor(public groupId: number) { }
}

export class GetOrganizationUsersSuccess {
  static readonly type = '[Organizations] Get Organization Users Success';
  constructor(public users: OrganizationUserModel[]) { }
}

export class GetOrganizationUsersFail {
  static readonly type = '[Organizations] Get Organization Users Fail';
  constructor(public error: Error) { }
}

export class ResetOrganizations {
  static readonly type = '[Organizations] Reset';
  constructor() { }
}

export class UpdateUserRoles {
  static readonly type = '[Organizations] Update User Roles';
  constructor(public groupId: number, public users: OrganizationUserRole[]) { }
}

export class UpdateUserRolesSuccess {
  static readonly type = '[Organizations] Update User Roles Success';
  constructor(public groupId: number, public users: OrganizationUserRole[]) { }
}

export class UpdateUserRolesFail {
  static readonly type = '[Organizations] Update User Roles Fail';
  constructor() { }
}

export class RemoveOrganizationUser {
  static readonly type = '[Organizations] Remove Organization User';
  constructor(public groupId: number, public users: UserContentTransfer[]) { }
}

export class RemoveOrganizationUserSuccess {
  static readonly type = '[Organizations] Remove Organization User Success';
  constructor(public groupId: number, public users: UserContentTransfer[]) { }
}

export class RemoveOrganizationUserFail {
  static readonly type = '[Organizations] Remove Organization User Fail';
  constructor() { }
}

export class TransferOrganizationContent {
  static readonly type = '[Organizations] Transfer Organization Content';
  constructor(public groupId: number, public users: UserContentTransfer[]) { }
}

export class TransferOrganizationContentSuccess {
  static readonly type = '[Organizations] Transfer Organization Content Success';
  constructor(public groupId: number, public users: UserContentTransfer[]) { }
}

export class TransferOrganizationContentFail {
  static readonly type = '[Organizations] Transfer Organization Content Fail';
  constructor() { }
}
